export default __webpack_public_path__ + "static/media/DashboardIcon.bd1d2e4c.svg";